// extracted by mini-css-extract-plugin
export var form = "_dl-0";